// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { BoundedAxis } from "./BoundedAxis";
import {
  BoundedAxisFromJSON,
  BoundedAxisFromJSONTyped,
  BoundedAxisToJSON,
  BoundedAxisToJSONTyped,
} from "./BoundedAxis";

/**
 *
 * @export
 * @interface BoundedGrid
 */
export interface BoundedGrid {
  /**
   *
   */
  x: BoundedAxis;
  /**
   *
   */
  y: BoundedAxis;
  /**
   * The Coordinate Reference System as an EPSG code, for example: 'EPSG:123456'. Raster transformations are done using PROJ4 version 9.6.0.
   */
  crs: string;
}

/**
 * Check if a given object implements the BoundedGrid interface.
 */
export function instanceOfBoundedGrid(value: object): value is BoundedGrid {
  if (!("x" in value) || value["x"] === undefined) return false;
  if (!("y" in value) || value["y"] === undefined) return false;
  if (!("crs" in value) || value["crs"] === undefined) return false;
  return true;
}

export function BoundedGridFromJSON(json: any): BoundedGrid {
  return BoundedGridFromJSONTyped(json, false);
}

export function BoundedGridFromJSONTyped(json: any, ignoreDiscriminator: boolean): BoundedGrid {
  if (json == null) {
    return json;
  }
  return {
    x: BoundedAxisFromJSON(json["x"]),
    y: BoundedAxisFromJSON(json["y"]),
    crs: json["crs"],
  };
}

export function BoundedGridToJSON(json: any): BoundedGrid {
  return BoundedGridToJSONTyped(json, false);
}

export function BoundedGridToJSONTyped(
  value?: BoundedGrid | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    x: BoundedAxisToJSON(value["x"]),
    y: BoundedAxisToJSON(value["y"]),
    crs: value["crs"],
  };
}
